var map = {
	"./sensormodels/AERIS-v0.2": 1157,
	"./sensormodels/AERIS-v0.2.json": 1157,
	"./sensormodels/BREEZE-v1.1": 6492,
	"./sensormodels/BREEZE-v1.1.json": 6492,
	"./sensormodels/BREEZE-v2.1": 6564,
	"./sensormodels/BREEZE-v2.1.json": 6564,
	"./sensormodels/CHICKADEE-v2.7": 1083,
	"./sensormodels/CHICKADEE-v2.7.json": 1083,
	"./sensormodels/COMFORT-VIVID-v2.2": 5888,
	"./sensormodels/COMFORT-VIVID-v2.2.json": 5888,
	"./sensormodels/COMFORT-VIVID-v3.1": 1840,
	"./sensormodels/COMFORT-VIVID-v3.1.json": 1840,
	"./sensormodels/COMFORT-VIVID-v4.0": 2919,
	"./sensormodels/COMFORT-VIVID-v4.0.json": 2919,
	"./sensormodels/COMFORT-VIVID-v4.2": 2663,
	"./sensormodels/COMFORT-VIVID-v4.2.json": 2663,
	"./sensormodels/COMFORT-VIVID-v4.3": 8717,
	"./sensormodels/COMFORT-VIVID-v4.3.json": 8717,
	"./sensormodels/HARMONY-v0.3": 3600,
	"./sensormodels/HARMONY-v0.3.json": 3600,
	"./sensormodels/HARMONY-v0.4": 904,
	"./sensormodels/HARMONY-v0.4.json": 904,
	"./sensormodels/HARMONY-v0.6": 8978,
	"./sensormodels/HARMONY-v0.6.json": 8978,
	"./sensormodels/Industrial-Transceiver-1wire-v1.11": 7763,
	"./sensormodels/Industrial-Transceiver-1wire-v1.11.json": 7763,
	"./sensormodels/Industrial-Transceiver-v2.1": 616,
	"./sensormodels/Industrial-Transceiver-v2.1.json": 616,
	"./sensormodels/KIWI-CLOVER-v2.0": 707,
	"./sensormodels/KIWI-CLOVER-v2.0.json": 707,
	"./sensormodels/MEMO-(demo)": 8080,
	"./sensormodels/MEMO-(demo).json": 8080,
	"./sensormodels/ORCA-v0.14": 4666,
	"./sensormodels/ORCA-v0.14.json": 4666,
	"./sensormodels/ORCA-v1.0": 2918,
	"./sensormodels/ORCA-v1.0.json": 2918,
	"./sensormodels/ROBIN-FINCH-v1.0": 408,
	"./sensormodels/ROBIN-FINCH-v1.0.json": 408,
	"./sensormodels/SEAL-v2.1": 7055,
	"./sensormodels/SEAL-v2.1.json": 7055,
	"./sensormodels/SEAL-v2.2": 9635,
	"./sensormodels/SEAL-v2.2.json": 9635,
	"./sensormodels/SPARROW-PELICAN-v2.8": 9215,
	"./sensormodels/SPARROW-PELICAN-v2.8.json": 9215,
	"./sensormodels/SPARROW-PELICAN-v3.1": 5466,
	"./sensormodels/SPARROW-PELICAN-v3.1.json": 5466,
	"./sensormodels/STORK-v2.0": 671,
	"./sensormodels/STORK-v2.0.json": 671,
	"./sensormodels/STORK-v2.1": 4691,
	"./sensormodels/STORK-v2.1.json": 4691,
	"./sensormodels/STORK-v2.2": 2529,
	"./sensormodels/STORK-v2.2.json": 2529,
	"./sensormodels/TUNDRA-v2.3": 2884,
	"./sensormodels/TUNDRA-v2.3.json": 2884,
	"./sensormodels/eBeat-v1.0": 7334,
	"./sensormodels/eBeat-v1.0.json": 7334,
	"./sensormodels/eBeat-v1.2": 3258,
	"./sensormodels/eBeat-v1.2.json": 3258,
	"./sensormodels/eBeat-v1.x": 270,
	"./sensormodels/eBeat-v1.x.json": 270,
	"./sensormodels/eDoctor-v0.15": 5633,
	"./sensormodels/eDoctor-v0.15.json": 5633,
	"./sensormodels/eDoctor-v1": 5695,
	"./sensormodels/eDoctor-v1.2": 7435,
	"./sensormodels/eDoctor-v1.2.json": 7435,
	"./sensormodels/eDoctor-v1.json": 5695
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2391;